export var TourFlag;
(function (TourFlag) {
    TourFlag["undoNote"] = "UNDO_NOTE";
    TourFlag["deleteDocument"] = "DELETE_DOCUMENT";
})(TourFlag || (TourFlag = {}));
